// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Prediction_wrapper__1bB5h","label":"Prediction_label__1sq4f"};